module.exports = __webpack_public_path__ + "static/media/Bondareva.5a8ecb57.jpg";